module.exports = {
  messages: {
    CN: {
      AIselection: "AI选择",
      ExplorePrimeBtn: "探索至尊版",
      ExplorePrime:
        "精简版/专业版用户只能选择一个AI机器人。如需两个，请升级到至尊版。",
      PrimePlan: "至尊版套餐 – 访问所有AI助手和高级功能！",
      AISslesRep: "AI销售代表",
      SmartSales: "智能销售助手：自动化您的销售流程并提高转化率。",
      AIRecruiter: "AI招聘师",
      SmartRecruiter: "智能招聘师：简化候选人筛选并优化招聘流程。",
      UpgradetoPrime: "升级到至尊版",
      Unlockboth: "解锁销售代表和招聘师两个机器人 + 高级功能，无限消息！",
      UpgradetoPrime99: "升级到高级版（999美元/年）",
      CancelKeep: "取消 – 保留单个机器人",
      ThePrimeversion: "与单独购买两个套餐相比，至尊版每年可为您节省500美元。",
      Soloentrepreneur: "独立创业者",
      ForEnterprises: "适用于企业",
      Firstname: "名字",
      EnterFirst: "请输入您的名字",
      lastName: "姓氏",
      EnterLastName: "请输入您的姓氏",
      Location: "位置",
      Email: "邮箱",
      enterEmail: "请输入您的邮箱",
      Companyname: "公司名称",
      enterCompanyname: "请输入您的公司名称",
      Companysize: "公司规模",
      Positon: "职位",
      Enteryourposition: "输入您的职位",
      pleaseEnterPos: "请输入您的职位",
      industry: "行业",
      Enteryourindustry: "输入您的行业",
      Pleaseenteryourindustry: "请输入您的行业",
      Orderdetail: "订单详情",
      liteplan: "精简版套餐",
      Proplan: "专业版套餐",
      PrimePlan2: "至尊版套餐",
      Billingcycle: "结算周期",
      Monthlypayment: "按月支付",
      Annualpayment: "按年支付",
      AnnualDiscount: "年度折扣 (17% 折扣)",
      Totalprice: "总价",
      Paynow: "立即支付",
      invoiceInformation: "账单和发票信息",
      SalesRep: "销售代表",
      Recruiter: "招聘专员",
      Enteryourrole: "输入您的角色",
      Pleaseenteryourrole: "请输入您的角色",
      Plaseselectlocation: "请选择地区",
      correctemial: "请输入正确的邮箱",
      PleaseselecteAI: "请选择AI",
      selectInstry: "请选择您的行业",
      selectcompanysize: "请选择您的公司规模",
      selectposition: "请选择您的职位",
      Enterrole: "输入您的角色",
      pleaseEntRole: "请输入您的角色",
      queryValid: "请确认查询有效！",
      selectplantype: "请选择一个订阅版本",
      Confirm: "确定",
      FreeTrial: "免费试用",
      Bindcard: "绑定卡片并继续试用",
      Havediscount: "有折扣码吗？",
      Enterdiscount: "输入折扣码",
      Entervalidcode: "请输入有效的折扣码",
      promocodeUsed: "该折扣码已过期",
      discountcodeLimit: "该折扣码已达到使用次数上限。",
      success: "成功",
      Extradiscount: "额外优惠",
      Tax: "税款：待定",
      BillingContact: "账单联系人",
      UserType: "用户类型",
      SelectUserType: "请选择用户类型",
      BillingAddress: "账单地址",
      CountryRegion: "国家/地区",
      SelectCountryRegion: "请选择国家/地区",
      State: "州/省",
      PleaseEnterState: "请输入您的州/省",
      StreetAddress: "街道地址",
      PleaseEnterStreetAddress: "请输入您的详细地址",
      City: "城市",
      PleaseEnterCity: "请输入您的城市",
      ZipCode: "邮政编码",
      PleaseEnterZipCode: "请输入您的邮政编码",
      EditInSetting: "在设置中编辑",
      formLoadError: "表单组件未正确加载，无法校验",
      BillingInformation: "账单信息",
      CompleteBillingInfo: "⚠️ 请完善您的账单信息",
      BillingAddressRequired:
        "账单地址是合规发票所必需的。此信息适用于您账户下的所有订阅",
      Edit: "编辑",
      Save: "保存",
    },

    US: {
      AIselection: "AI selection",
      ExplorePrime:
        "Lite/Pro users can pick only one AI bot. For two, upgrade to Prime.",
      ExplorePrimeBtn: "Explore Prime",
      PrimePlan: " Prime Plan – Access all AI assistants and premium features!",
      AISslesRep: "AI Sales Rep",
      SmartSales:
        "Smart Sales Assistant: Automate your sales process and boost conversion rates.",
      AIRecruiter: "AI Recruiter",
      SmartRecruiter:
        "Smart Recruiter Streamline candidate screening and optimize hiring workflows.",
      UpgradetoPrime: "Upgrade to Prime",
      Unlockboth:
        "Unlock both Sales Rep & Recruiter bots + premium features，with unlimited messages!",
      UpgradetoPrime99: "Upgrade to Prime ($999/year)",
      CancelKeep: "Cancel – Keep single bot",
      ThePrimeversion:
        "The Prime version saves you $500/year compared to buying the two plans separately. ",
      Soloentrepreneur: "Solo entrepreneur",
      ForEnterprises: "For Enterprises",
      Firstname: "First name",
      EnterFirst: "Please enter your first name",
      lastName: "Last name",
      EnterLastName: "Please enter your last name",
      Location: "Location",
      Email: "Email",
      enterEmail: "Please enter your email",
      Companyname: "Company name",
      enterCompanyname: "Please enter your company name",
      Companysize: "Company size",
      Positon: "Positon",
      Enteryourposition: "Enter your position",
      pleaseEnterPos: "Please enter your position",
      industry: "industry",
      Enteryourindustry: "Enter your industry",
      Pleaseenteryourindustry: "Please enter your industry",
      Orderdetail: "Order detail",
      liteplan: "lite plan",
      Proplan: "Pro plan",
      PrimePlan2: "Prime Plan",
      Billingcycle: "Billing cycle",
      Monthlypayment: "Monthly payment",
      Annualpayment: "Annual payment",
      AnnualDiscount: "Annual Discount (17% OFF)",
      Totalprice: "Total price",
      Paynow: "Pay now",
      invoiceInformation: "Billing & invoice Information",
      SalesRep: "Sales Rep",
      Recruiter: "Recruiter",
      Enteryourrole: "Enter your role",
      Pleaseenteryourrole: "Please enter your role",
      Plaseselectlocation: "Plase select location",
      correctemial: "Please enter a correct emial",
      PleaseselecteAI: "Please selecte AI",
      selectInstry: "Please select your industry",
      selectcompanysize: "Please select your company size",
      selectposition: "Please select your position",
      Enterrole: "Enter your role",
      pleaseEntRole: "Please enter your role",
      queryValid: "please confirm query is valid!",
      selectplantype: "please select plan type",
      Confirm: "Confirm",
      FreeTrial: "Free Trial",
      Bindcard: "Bind card and continue trial",
      Havediscount: "Have a discount code?",
      Enterdiscount: "Enter a discount code",
      Entervalidcode: "Enter a valid code",
      promocodeUsed: "The promo code has expired",
      discountcodeLimit: "The discount code has reached its usage limit.",
      success: "success",
      Extradiscount: "Extra discount",
      Tax: "Tax:To be determined",
      BillingContact: "Billing contact",
      UserType: "User Type",
      SelectUserType: "Select User Type",
      BillingAddress: "Billing Address",
      CountryRegion: "Country / Region",
      SelectCountryRegion: "Select country / Region",
      State: "State",
      PleaseEnterState: "Please enter your state",
      StreetAddress: "Street Address",
      PleaseEnterStreetAddress: "Please enter your street address",
      City: "City",
      PleaseEnterCity: "Please enter your city",
      ZipCode: "Zip code",
      PleaseEnterZipCode: "Please enter your ZIP code",
      EditInSetting: "Edit in setting",
      formLoadError: "Form component not loaded properly, cannot validate",
      BillingInformation: "Billing information",
      CompleteBillingInfo: "⚠️ Complete your billing information",
      BillingAddressRequired:
        "A billing address is required for tax-compliant invoices. This info applies to all subscriptions under your account",
      Edit: "Edit",
      Save: "Save",
    },
    AR: {
      AIselection: "اختيار الذكاء الاصطناعي",
      ExplorePrimeBtn: "اكتشف Prime",
      ExplorePrime:
        "يمكن لمستخدمي Lite/Pro اختيار بوت ذكاء اصطناعي واحد فقط. للحصول على اثنين، قم بالترقية إلى Prime.",
      PrimePlan:
        "خطة Prime - الوصول إلى جميع مساعدي الذكاء الاصطناعي والميزات المميزة!",
      AISslesRep: "مندوب مبيعات الذكاء الاصطناعي",
      SmartSales:
        "مساعد المبيعات الذكي: أتمتة عملية المبيعات الخاصة بك وزيادة معدلات التحويل.",
      AIRecruiter: "موظف توظيف بالذكاء الاصطناعي",
      SmartRecruiter:
        "موظف التوظيف الذكي تبسيط فحص المرشحين وتحسين سير عمل التوظيف.",
      UpgradetoPrime: "الترقية إلى Prime",
      Unlockboth:
        "افتح كلا الروبوتين الخاصين بمندوب المبيعات وموظف التوظيف + الميزات المميزة، مع رسائل غير محدودة!",
      UpgradetoPrime99: " الترقية إلى Prime (999 دولارًا/سنة)",
      CancelKeep: "إلغاء - الاحتفاظ بروبوت واحد",
      ThePrimeversion:
        "يوفر لك إصدار Prime 500 دولارًا سنويًا مقارنة بشراء الخطتين بشكل منفصل.",
      Soloentrepreneur: "رائد أعمال منفرد",
      ForEnterprises: "للمؤسسات",
      Firstname: "الاسم الأول",
      EnterFirst: "الرجاء إدخال اسمك الأول",
      lastName: " اسم العائلة",
      EnterLastName: "الرجاء إدخال اسم عائلتك",
      Location: "الموقع",
      Email: "البريد الإلكتروني",
      enterEmail: "الرجاء إدخال بريدك الإلكتروني",
      Companyname: "اسم الشركة",
      enterCompanyname: "الرجاء إدخال اسم شركتك",
      Companysize: "حجم الشركة",
      Positon: "الوظيفة",
      Enteryourposition: "أدخل وظيفتك",
      pleaseEnterPos: "الرجاء إدخال وظيفتك",
      industry: "الصناعة",
      Enteryourindustry: "أدخل صناعتك",
      Pleaseenteryourindustry: "الرجاء إدخال صناعتك",
      Orderdetail: "تفاصيل الطلب",
      liteplan: "الخطة الخفيفة",
      Proplan: "الخطة الاحترافية",
      PrimePlan2: "خطة Prime",
      Billingcycle: "دورة الفوترة",
      Monthlypayment: "الدفع الشهري",
      Annualpayment: "الدفع السنوي",
      AnnualDiscount: "خصم سنوي (خصم 17%)",
      Totalprice: " السعر الإجمالي",
      Paynow: "ادفع الآن",
      invoiceInformation: "معلومات الفواتير والفاتورة",
      SalesRep: "مندوب مبيعات",
      Recruiter: "مسؤول توظيف",
      Enteryourrole: "أدخل دورك",
      Pleaseenteryourrole: "الرجاء إدخال دورك",
      Plaseselectlocation: "الرجاء تحديد الموقع",
      correctemial: "الرجاء إدخال بريد إلكتروني صحيح",
      PleaseselecteAI: "الرجاء اختيار الذكاء الاصطناعي",
      selectInstry: "الرجاء اختيار مجال عملك",
      selectcompanysize: "الرجاء تحديد حجم شركتك",
      selectposition: "الرجاء تحديد منصبك",
      Enterrole: "أدخل دورك",
      pleaseEntRole: " يُرجى إدخال دورك",
      queryValid: "العربية: يُرجى التأكد من صحة الاستعلام!",
      selectplantype: "الرجاء تحديد نوع الخطة.",
      Confirm: "تأكيد",
      FreeTrial: "نسخة تجريبية مجانية",
      Bindcard: "ربط البطاقة ومتابعة التجربة",
      Havediscount: "هل لديك كود خصم؟",
      Enterdiscount: "أدخل كود الخصم",
      Entervalidcode: "أدخل كوداً صالحاً",
      promocodeUsed: "لقد انتهت صلاحية كود الترويج",
      discountcodeLimit: "وصل كود الخصم إلى حد الاستخدام الأقصى.",
      success: "نجاح",
      Extradiscount: "خصم إضافي",
      Tax: " الضريبة: قيد التحديد",
      BillingContact: "جهة اتصال الفواتير",
      UserType: "نوع المستخدم",
      SelectUserType: "اختر نوع المستخدم",
      BillingAddress: "عنوان الفوترة",
      CountryRegion: "الدولة / المنطقة",
      SelectCountryRegion: "اختر الدولة / المنطقة",
      State: "الولاية",
      PleaseEnterState: "الرجاء إدخال ولايتك",
      StreetAddress: "عنوان الشارع",
      PleaseEnterStreetAddress: "الرجاء إدخال عنوان الشارع الخاص بك",
      City: "المدينة",
      PleaseEnterCity: "الرجاء إدخال مدينتك",
      ZipCode: "الرمز البريدي",
      PleaseEnterZipCode: "الرجاء إدخال رمزك البريدي",
      EditInSetting: "تعديل في الإعدادات",
      formLoadError: "لم يتم تحميل مكون النموذج بشكل صحيح، لا يمكن التحقق",
      BillingInformation: "معلومات الفواتير",
      CompleteBillingInfo: "⚠️ أكمل معلومات الفوترة الخاصة بك",
      BillingAddressRequired:
        "عنوان الفوترة مطلوب للفواتير المتوافقة مع الضرائب. تنطبق هذه المعلومات على جميع الاشتراكات تحت حسابك",
      Edit: "تعديل",
      Save: "حفظ",
    },
  },
};
